import React from 'react';
import { InterviewTemplate } from '../../../../entities/applicant_tracking/InterviewTemplate';
import InterviewTemplatePage from '../InterviewTemplatePage';
import { ActionType } from '../../../../enums/ActionType';

interface PropTypes {
  interviewTemplate: InterviewTemplate;
}

export default function EditInterviewTemplatePage(props: PropTypes) {
  return (
    <InterviewTemplatePage
      interviewTemplate={props.interviewTemplate}
      meetingOrganizer={props.interviewTemplate.meetingOrganizer}
      actionType={ActionType.Edit}
    />
  );
}
